<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="save"
        hide-header
        persistent
        ref="RkmModal"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.prioridades"
                        :validations="validations.prioridade"
                        label="Prioridade"
                        show-default-option
                        text-field="nome"
                        v-model="model.prioridadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                prioridade: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            fila: this.getConectaSusRepository('prontoAtendimento.fila'),
        }
    },
    data: () => ({
        filaId: null,
        model: {
            prioridadeId: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(filaId, prioridadeId) {
            this.reset()

            this.filaId = filaId
            this.model.prioridadeId = prioridadeId

            this.$refs.RkmModal.show()
        },
        save() {
             this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {prioridadeId: this.model.prioridadeId}

                    this.repositories.fila.update(this.filaId, this.camelObjectKeysToSnakeRecursive(request))
                        .then(() => {
                            this.$emit('saved')

                            this.close()

                            this.showSaveNotification()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        close() {
            this.$refs.RkmModal.hide()
        },
        reset() {
            this.filaId = null,
            this.model.prioridadeId = null
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        form: {type: Object, required: true},
    },
}
</script>